import { render, staticRenderFns } from "./TicketManagement.vue?vue&type=template&id=74d563fa"
import script from "./TicketManagement.vue?vue&type=script&lang=js"
export * from "./TicketManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports